import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import HeaderCard from "../../components/tosan/HeaderCard";
import ListItem from "../../components/ListItem";
import Button from "../../components/newComponents/button/Button";
import BillTypes from "../../tools/defaults/tosan/billTypes";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/tosan/modals/ErrorModal";
import LoadingModal from "../../components/tosan/modals/LoadingModal";
import CreateProcess from "../../tools/api/tosan/CreateProcess";
import TelBillSelect from "../../components/tosan/billInfo/TelBillSelect";
import MobileBillSelect from "../../components/tosan/billInfo/MobileBillSelect";
import DataContext from "../../tools/contexts/tosan/DataContext";
import genUuid from "../../tools/api/tosan/genUuid";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'
import addBill from "../../tools/api/tosan/addBill";
import BillDetailModal from "../../components/tosan/modals/BillDetailModal";
import billTypes from "../../tools/defaults/tosan/billTypes";
import useAxiosCancel from "../../tools/hoc/useAxiosCancel";

const BillDetail = () => {
    const {state} = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const type = searchParams.get('type');
    const serviceType = searchParams.get('serviceType');
    const dataContext = useContext(DataContext)
    const parameter = searchParams.get('parameter');
    const [data, setData] = useState((state && state?.data) ? state.data.data : null);
    const [billHashId, setBillHashId] = useState(state?.data?.BillHashId ? state?.data?.BillHashId : null);
    const [isPayable, setIsPayable] = useState(false);
    const [isDisable, setIsDisabled] = useState(type === 'TelBills' || type === 'MobileBills');
    const [selectedType, setSelectedType] = useState(type);
    const [selectedBillInfo, setSelectedBillInfo] = useState(null);
    const [loading, setLoading] = useState(!state?.data);
    const getCancelToken = useAxiosCancel();
    useEffect(() => {
        if (state && state.data) {

            if (type !== 'TelBills' && type !== 'MobileBills')
                handleCheckPayable(state.data)
        } else {
            handleBillInquiry();
        }

    }, []);
    const handleBillInquiry = async () => {
        setLoading(true);
        const cancelToken=getCancelToken();
        const response = await genUuid(dataContext.token, {
            request_type: 'BillInquiry',
            callback_url: "https://venesh.ir"
        }, cancelToken);

        if (response.isOk) {

            if (response.data.uuid && response.data.request_type) {

                const data = {
                    Type: type,
                    uuid: response.data.uuid,
                    Parameter: parameter,
                    Info: 1,

                }
                const inquiryResponse = await addBill(dataContext.token, data, cancelToken);
                setLoading(false)
                if (inquiryResponse.isOk) {
                    if (type !== 'TelBills' && type !== 'MobileBills')
                        handleCheckPayable(inquiryResponse.data);
                    setData(inquiryResponse.data.data);

                    setBillHashId(inquiryResponse.data.BillHashId)
                } else {

                    if(!inquiryResponse.canceled)
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: inquiryResponse.message,
                        confirmButtonTheme: inquiryResponse.status === 106 ? "primary" : "danger",
                        confirmButtonText: inquiryResponse.status === 106 ? "بازگشت" :"تلاش مجدد",
                        showCancelButton:inquiryResponse.status === 110,
                        showConfirmButton:true,
                        cancelButtonText:"بازگشت",
                        cancelButtonTheme:"link",
                        onCancel:()=>{
                          navigate(-1);
                            Reoverlay.hideModal()
                        },
                        onConfirm: () => {
                            if (inquiryResponse.status === 106) {
                                navigate(-1);
                                Reoverlay.hideModal()
                            } else {
                                Reoverlay.hideModal()
                                handleBillInquiry()
                            }

                        }
                    })
                }

            }

        } else {
            setLoading(false);

            if(!response.canceled)
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: response.message,
                cancelButtonTheme: "danger",
                onCancel: () => {
                    handleBillInquiry();
                    Reoverlay.hideModal()
                }
            })
        }
    }
    const handleSelectType = (selectedType, selectedInfo) => {

        setIsDisabled(false)
        setSelectedType(selectedType);
        setSelectedBillInfo(selectedInfo);
        handleCheckPayable({data: selectedInfo})
    }
    const handleCreateProcess = async () => {
        const cancelToken=getCancelToken();
        const ArrayType = ['Tel', 'TelNow', 'Mobile', 'MobileNow']
        Reoverlay.showModal(LoadingModal, {text: 'لطفا منتظر بمانید.'});
        const params = {
            BillHashId: billHashId,
            Type: selectedType && ArrayType.includes(selectedType) ? selectedType : null
        }
        const response = await CreateProcess(dataContext.token, params,cancelToken);
        Reoverlay.hideModal()
        if (response.isOk) {
            const params = {
                serviceType: serviceType,
                parameter: parameter,

            }
            const queryParams = new URLSearchParams(params);
            navigate('/tosan/getDeposits?' + queryParams.toString(), {
                state: {
                    billInfo: selectedBillInfo || data,
                    type: selectedType || type,
                    processData: response.data,
                }
            })
        } else {

            if(!response.canceled)
            Reoverlay.showModal(ErrorModal, {
                title: 'ناموفق',
                message: response.message,
                onCancel: () => {
                    Reoverlay.hideModal()
                },
                cancelButtonText: 'بستن',
                cancelButtonTheme: "danger",
                showCancelButton: true,
            })
        }


    }
    const handleCheckPayable = (bill) => {
        setIsPayable(bill && bill?.data?.Amount.value > 0 && bill?.data?.PayId.value.length > 5)
    }
    const handleBack = () => {
        navigate('/tosan/' + serviceType)
    }
    const showMoreDetail = () => {
        if (data?.Info) {

            Reoverlay.showModal(BillDetailModal, {
                serviceType: serviceType,
                type: type,
                data: data.Info,
                onClose: () => {
                    Reoverlay.hideModal();
                }
            })
        }
    }
    return <div>
        <HeaderCard hasBack={false} onBack={handleBack}
                    className="flex justify-center default-header-card flex-col items-center ">
            <h1 className="title">{billTypes[serviceType].title}</h1>
        </HeaderCard>
        <div className="w-full flex flex-col  justify-between p-5">
            {loading && <Skeleton baseColor="#E5E5E5" height={35} count={4}/>}
            {!loading && data && <>
                {type !== "TelBills" && type !== "MobileBills" && <div className="w-full  rounded-lg overflow-hidden">
                    <div className="w-full p-3 bg-white flex justify-between text-sm items-center">
                        <span>{data?.Info?.OwnerName?.value ? data?.Info?.OwnerName?.value : BillTypes[serviceType].title}</span><Button
                        className="px-2" onClick={showMoreDetail} rounded="rounded-full" size="x-small">جزییات</Button>
                    </div>
                    <ListItem isPrice={true} isGreen={true} value={data?.Amount?.value} title={data?.Amount?.faName}/>
                    <ListItem value={data?.BillId?.value} title={data?.BillId?.faName}/>
                    <ListItem value={data?.PayId?.value} title={data?.PayId?.faName}/>
                </div>}
                {type === "TelBills" && <TelBillSelect parameter={parameter} onSelect={handleSelectType} bill={data}/>}
                {type === "MobileBills" &&
                    <MobileBillSelect parameter={parameter} onSelect={handleSelectType} bill={data}/>}

            </>}
            {!loading && <div className="w-full bottom-2 fixed grid grid-cols-2  gap-2 right-0 px-5 ">
                <Button onClick={handleBack}  type="button" rounded="rounded" className={'w-full'} theme="link">بازگشت</Button>
                <Button onClick={handleCreateProcess} disabled={isDisable || !isPayable} theme="primary"
                        className="  w-full " rounded="rounded">تایید و ادامه</Button>
            </div>}


        </div>
    </div>
}
export default BillDetail;